<div
  class="main-sidebar"
  [class.expanded]="!isCollapsed"
  [class.hidden]="isCollapsed"
  [class.mobile-open]="mobileMenuExpanded$ | async"
  role="navigation"
  [attr.aria-label]="'translations.global.ariaLabels.adminNavigation' | transloco"
>
  <button
    type="button"
    class="edge-toggle"
    [attr.aria-label]="
      (isCollapsed ? 'translations.global.ariaLabels.expandSidebar' : 'translations.global.ariaLabels.collapseSidebar') | transloco
    "
    [attr.aria-expanded]="!isCollapsed"
    (click)="onToggleCollapse()"
  >
    <ptl-icon [icon]="isCollapsed ? LucideChevronRight : LucideChevronLeft" [size]="'s'" [color]="'currentColor'"></ptl-icon>
  </button>
  <div class="sidebar-content">
    <div class="navigation-items-container">
      <div class="collapse-menu-container" [class.collapsed]="isCollapsed">
        <div class="sidebar-heading" [attr.inert]="isCollapsed ? '' : null">
          @if (backLink) {
            <a class="back-link" [routerLink]="backLink.url" [queryParams]="backLink.queryParams ?? null">
              <ptl-icon [icon]="LucideChevronLeft" [size]="'s'"></ptl-icon>
              <span>{{ backLink.label }}</span>
            </a>
          }

          <div *ngIf="title" class="sidebar-title fs-body-m semibold">
            <span class="title-text">{{ title }}</span>
          </div>
        </div>
      </div>

      <div class="nav-content" [class.hidden]="isCollapsed">
        <div class="sidebar-projected-content">
          <ng-content></ng-content>
        </div>

        <div class="sidebar-projected-footer">
          <ng-content select="[sidebarFooter]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
